import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector'
import React from 'react'
import { defineMessages } from 'react-intl'
import { EXERCISE_DETAILS_KEY } from '@gymaholic/packages'
import {
  compactObjectUtil,
  isEmptyUtil,
  logUtil,
  pickObjectUtil
} from 'packages/src'
import { View } from 'components/View'
import { getDetailsByIdExerciseSelector } from 'modules/exercise/redux/selectors/get-details-by-id/index.js'
import Text from 'components/Text.js'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html/index.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { getNameByIdExerciseSelector } from 'modules/exercise/redux/selectors/get-name-by-id/index.js'
import Collapsible from 'components/Collapsible/index.js'

const messages = defineMessages({
  howToDo: {
    id: 'ExerciseDetails.howToDo',
    defaultMessage: 'How to do the {exerciseName}'
  },
  benefits: {
    id: 'ExerciseDetails.benefits',
    defaultMessage: 'Benefits of the {exerciseName}'
  },
  tips: {
    id: 'ExerciseDetails.tips',
    defaultMessage: 'Tips for performing the {exerciseName}'
  }
})

const KEYS = [
  EXERCISE_DETAILS_KEY.HOW_TO_DO,
  EXERCISE_DETAILS_KEY.BENEFITS,
  EXERCISE_DETAILS_KEY.TIPS
]

const KEY_TO_MESSAGE = {
  [EXERCISE_DETAILS_KEY.HOW_TO_DO]: messages.howToDo,
  [EXERCISE_DETAILS_KEY.BENEFITS]: messages.benefits,
  [EXERCISE_DETAILS_KEY.TIPS]: messages.tips
}

export default function ExerciseDetails ({ id }) {
  const details = useSelector(getDetailsByIdExerciseSelector(id))
  const exerciseName = useSelector(getNameByIdExerciseSelector(id))
  const firstDetails = details?.[0] || {}
  const detailsToUse = compactObjectUtil(
    pickObjectUtil(firstDetails, KEYS)
  )
  const intl = useIntl()
  const debugProps = {
    details,
    detailsToUse
  }
  logUtil('ExerciseDetails').debug('debugProps=', debugProps)

  if (isEmptyUtil(detailsToUse)) {
    return <></>
  }

  return (
    <View>
      {
        KEYS.map((key) => {
          const value = detailsToUse[key]
          const label = formatMessageIntlUtil(intl, KEY_TO_MESSAGE[key], {
            exerciseName
          })

          return (
            <View
              mt={2}
              key={key}
            >

              <Collapsible label={label}>
                <Text
                  key={key}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: markdownToHtmlStringUtil(value)
                    }}
                  />
                </Text>
              </Collapsible>
            </View>
          )
        })
      }
    </View>
  )
}
